import Undo from 'undo.js';

export class BringToFrontCommand extends Undo.Command {

  constructor (layer, features) {
    super();
    this.layer = layer;
    this.features = features.slice();
    const allFeatures = layer.getFeatureLayer().getSource().getFeatures();
    this.initialFeatureOrder = allFeatures.map(feature => feature.ol_uid);
  }

  execute () {
    this.layer.bringFeaturesToFront(this.features);
  }

  undo () {
    this.layer.setFeaturesOrder(this.initialFeatureOrder);
  }

}
